import { jsx as _jsx } from "react/jsx-runtime";
const React = require("react");
export const AanZetSearchIcon = /*#__PURE__*/ _jsx("span", {
    className: "icon icon-search",
    "aria-hidden": "true"
});
